module.exports = __webpack_public_path__ + "media/8.a6fc48c4.mp3";